import { render, staticRenderFns } from "./app_bar_help.vue?vue&type=template&id=1282a55b&"
import script from "./app_bar_help.vue?vue&type=script&lang=js&"
export * from "./app_bar_help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports